import React, { useEffect, useState, useRef } from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
interface SignatureCanvasProps {
  onSave: (signature: string) => void;
}
export function SignatureCanvas({
  onSave
}: SignatureCanvasProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [hasDrawn, setHasDrawn] = useState(false);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    // Set canvas size
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    // Set drawing style
    ctx.strokeStyle = '#000000';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
  }, []);
  const startDrawing = (e: React.MouseEvent<HTMLCanvasElement> | React.TouchEvent<HTMLCanvasElement>) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    setIsDrawing(true);
    setHasDrawn(true);
    const rect = canvas.getBoundingClientRect();
    const x = 'touches' in e ? e.touches[0].clientX - rect.left : e.clientX - rect.left;
    const y = 'touches' in e ? e.touches[0].clientY - rect.top : e.clientY - rect.top;
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const draw = (e: React.MouseEvent<HTMLCanvasElement> | React.TouchEvent<HTMLCanvasElement>) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const rect = canvas.getBoundingClientRect();
    const x = 'touches' in e ? e.touches[0].clientX - rect.left : e.clientX - rect.left;
    const y = 'touches' in e ? e.touches[0].clientY - rect.top : e.clientY - rect.top;
    ctx.lineTo(x, y);
    ctx.stroke();
  };
  const stopDrawing = () => {
    setIsDrawing(false);
  };
  const clearCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    setHasDrawn(false);
  };
  const saveSignature = () => {
    const canvas = canvasRef.current;
    if (!canvas || !hasDrawn) return;
    const dataUrl = canvas.toDataURL('image/png');
    onSave(dataUrl);
  };
  return <div className="space-y-3" data-id="element-5543">
      <div className="relative" data-id="element-5544">
        <canvas ref={canvasRef} onMouseDown={startDrawing} onMouseMove={draw} onMouseUp={stopDrawing} onMouseLeave={stopDrawing} onTouchStart={startDrawing} onTouchMove={draw} onTouchEnd={stopDrawing} className="w-full h-32 border-2 border-gray-300 rounded-lg cursor-crosshair bg-white touch-none" style={{
        touchAction: 'none'
      }} data-id="element-5545" />
        <div className="absolute top-2 right-2 text-xs text-gray-400 pointer-events-none" data-id="element-5546">
          Semnează aici
        </div>
      </div>

      <div className="flex gap-2" data-id="element-5547">
        <button onClick={clearCanvas} disabled={!hasDrawn} className="flex-1 flex items-center justify-center space-x-2 px-4 py-2 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-5548">
          <XIcon className="w-4 h-4" data-id="element-5549" />
          <span data-id="element-5550">Șterge</span>
        </button>

        <button onClick={saveSignature} disabled={!hasDrawn} className="flex-1 flex items-center justify-center space-x-2 px-4 py-2 bg-[#21A366] text-white rounded-lg font-semibold hover:bg-[#1a8555] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-5551">
          <CheckIcon className="w-4 h-4" data-id="element-5552" />
          <span data-id="element-5553">Salvează</span>
        </button>
      </div>
    </div>;
}